var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8666 9.20713L10.2083 16.8655C9.27011 17.8037 7.99763 18.3307 6.67081 18.3307C5.34399 18.3307 4.07151 17.8037 3.13331 16.8655C2.19511 15.9273 1.66803 14.6548 1.66803 13.328C1.66803 12.0011 2.19511 10.7287 3.13331 9.79046L10.7916 2.13213C11.4171 1.50666 12.2654 1.15527 13.15 1.15527C14.0345 1.15527 14.8828 1.50666 15.5083 2.13213C16.1338 2.7576 16.4852 3.60591 16.4852 4.49046C16.4852 5.37501 16.1338 6.22333 15.5083 6.84879L7.84164 14.5071C7.52891 14.8199 7.10475 14.9956 6.66248 14.9956C6.2202 14.9956 5.79604 14.8199 5.48331 14.5071C5.17058 14.1944 4.99488 13.7702 4.99488 13.328C4.99488 12.8857 5.17058 12.4615 5.48331 12.1488L12.5583 5.08213",
    stroke: "#535353",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.93ba3c1594d15279ad18ff6d75f91e64.svg";
export { ForwardRef as ReactComponent };